export default __webpack_public_path__ + "static/media/liveCourse.28157b21.svg";